<template>
  <q-card
    v-for="(item, index) in quickWinsHighlightsData"
    :key="item.fab_code || item.fab_zone"
    class="rounded-xl border border-neutral-100/5 shadow-sm"
  >
    <div
      class="text-title-3 !text-[1.25rem] !font-normal h-80 py-8 px-24 flex items-center gap-16 justify-between md2:px-16"
    >
      <div class="flex items-center gap-8">
        <h1 v-if="item?.isPriority">{{ item?.fab_name }}</h1>

        <OSelectPaginated
          v-else
          label="Selecione um fabricante"
          :model-value="item.selectedBottler"
          :update-on-focus="true"
          :adictional-filters="{
            fab_tier: filterParams.fab_tier,
            fab_tier_type: filterParams.fab_tier_type,
            fab_zone: filterParams.fab_zone,
            t: 'global',
          }"
          api-url="copa/api/filters/bottlers/"
          option-label="fab_name"
          option-value="fab_code"
          class="bg-white"
          @update:model-value="
            (val) => {
              item.selectedBottler = val.fab_code
              onSelectBottler(val.fab_code, index)
            }
          "
        />
      </div>
      <q-spinner-tail
        v-if="quickWinsHighlightsLoading"
        color="primary"
        size="1.25rem"
      />
    </div>

    <div
      v-if="item?.showCards !== false"
      class="flex flex-col gap-24 p-24 !pt-0 md2:gap-8 md2:p-16"
    >
      <q-card class="rounded-xl border border-neutral-100/5 shadow-sm p-16">
        <CardMyQuickWins :title-small="true" :item="item" />
      </q-card>

      <q-card class="rounded-xl border border-neutral-100/5 shadow-sm p-16">
        <CardMyHighlights :title-small="true" :item="item" />
      </q-card>
    </div>
  </q-card>
</template>

<script setup>
import CardMyQuickWins from './CardMyQuickWins.vue'
import CardMyHighlights from './CardMyHighlights.vue'
import OSelectPaginated from 'components/Select/OSelectPaginated.vue'
import useCopaReports from 'composables/useCopaReports'
import {
  filterParams,
  quickWinsHighlightsData,
  quickWinsHighlightsLoading,
} from 'store/copa.stores'

const { selectBottlerForQuickWins } = useCopaReports()

const onSelectBottler = async (selectedBottler, itemIndex) => {
  if (!selectedBottler) return
  await selectBottlerForQuickWins(selectedBottler, itemIndex)
}
</script>

<style scoped lang="sass">
:deep(.q-select.q-field--float .q-field__label)
  background: #FFF !important
  padding: 0 .25rem !important
  transform: translateY(-60%) translateX(1px) scale(0.75) !important
</style>
